import React from "react";
import "./HostEnquiryInfo.scss";
import {
  EnquiryInfoItem,
  EnquiryInfoItems,
  EnquiryInfoChipItem,
} from "venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoItem";
import { PaymentInfo } from "./PaymentInfo";
import { DateEnquiryInfo, TimeEnquiryInfo } from "./TimeEnquiryInfoItems";

export function HostEnquiryInfo({ state, thread, space, venue, hasCtas }) {
  return (
    <div className={hasCtas ? "enquiry-info" : "enquiry-info hasNoCtas"}>
      <div className="enquiry__block">
        <EnquiryInfoItems>
          <EnquiryInfoItem title="Event type" value={thread.event_type} />
          <EnquiryInfoItem
            title="Budget"
            value={thread.cumulativeOffer.org_budget}
          />
          <EnquiryInfoItem title="Venue" value={venue.name} />
          <EnquiryInfoItem title="Space" value={space.data().name} />
          <EnquiryInfoItem
            title="Guests"
            value={thread.cumulativeOffer.capacity}
          />
          <DateEnquiryInfo value={thread.localDates} />
          <TimeEnquiryInfo value={thread.localDates} />
          {thread.lead && (
            <EnquiryInfoChipItem title="Source" value="MatchLeads" />
          )}
          {(state.matches("quoteReceived") || state.matches("booked")) && (
            <PaymentInfo thread={thread} />
          )}
        </EnquiryInfoItems>
      </div>
    </div>
  );
}
